export default function anonymous(context
) {
var out='';var calls = [ ];var arr1=context.object.calling;if(arr1){var call,i=-1,l1=arr1.length-1;while(i<l1){call=arr1[i+=1];if(call !== ' '){ calls.push((call === 's')? 's' + (i + 1): (i + 1)) }} } out+=''+( calls.join(' ') );return out;
}